import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import Form from '../common/Form'
import InputContainer from '../../containers/common/InputContainer'
import { Spin } from '../common/Ant'
import Button from '../common/Button'
import CancelButton from '../common/CancelButton'
import Divider from '../common/Divider'
import FormError from '../common/FormError'
import { required } from '../../utils/validators'

const EditCarrierForm = props => {
  const {
    handleSubmit,
    submitting,
    error,
    submitAction,
    isCarrierLoading,
  } = props

  const submit = handleSubmit(submitAction)
  return isCarrierLoading ? (
    <Spin size="large" className="w-100 center mv5" />
  ) : (
    <section className="EditCarrierForm">
      <Form onSubmit={submit}>
        <div className="flex-ns">
          <Field
            name="name"
            type="text"
            component={InputContainer}
            label="Name"
            validate={[required]}
            className="w-100"
          />
        </div>
        <Divider />
        <FormError error={error} />
        <div className="flex justify-between">
          <CancelButton defaultLocation="/inventory/all/carriers" />
          <Button text="Submit" type="submit" submitting={submitting} />
        </div>
      </Form>
    </section>
  )
}

EditCarrierForm.propTypes = {
  submitAction: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  isCarrierLoading: PropTypes.bool,
  error: PropTypes.string,
}

export default reduxForm({ form: 'EditCarrierForm' })(EditCarrierForm)
